import React, {useEffect, useState} from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import {useTranslation} from "react-i18next";
import CustomDialog from "../custom-dialog";
import {isValidIntegerInInclusiveRange} from "../../utils/validator";

const HEIGHT_TYPE_STANDARD = "standard";
const HEIGHT_TYPE_CUSTOM = "custom";

const RowHeigthDialog = ({initialValue, open, onClose, onSubmit}) => {
  const {t} = useTranslation();

  const [heightType, setHeightType] = useState(HEIGHT_TYPE_STANDARD);
  const [height, setHeight] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (initialValue) {
      setHeightType(HEIGHT_TYPE_CUSTOM);
      setHeight(initialValue);
    } else {
      setHeightType(HEIGHT_TYPE_STANDARD);
    }
  }, [initialValue]);

  const handleSubmit = () => {
    if (heightType === HEIGHT_TYPE_CUSTOM) {
      if (isValidIntegerInInclusiveRange(height, 1)) {
        setError(false);
        onSubmit(height);
      } else {
        setError(true);
      }
    } else {
      setError(false);
      onSubmit(null);
    }
  };

  return (
    <CustomDialog id="item-container-builder__row-height-dialog" open={open} onClose={onClose}>
      <DialogTitle>{t("components.itemContainerBuilder.modals.height.title")}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <TextField
            select
            label={t("components.itemContainerBuilder.modals.height.select.label")}
            id="item-container-builder__row-height-dialog__select"
            value={heightType}
            onChange={e => setHeightType(e.target.value)}
            variant="outlined"
          >
            <MenuItem value={HEIGHT_TYPE_STANDARD}>
              {t("components.itemContainerBuilder.modals.height.select.option.standard")}
            </MenuItem>
            <MenuItem value={HEIGHT_TYPE_CUSTOM}>
              {t("components.itemContainerBuilder.modals.height.select.option.custom")}
            </MenuItem>
          </TextField>
        </FormControl>
        {heightType === HEIGHT_TYPE_CUSTOM && (
          <FormControl fullWidth sx={{pt: "16px"}}>
            <TextField
              autoFocus
              required
              error={error}
              helperText={error && t("components.itemContainerBuilder.modals.height.input.error")}
              value={height}
              onChange={e => setHeight(e.target.value)}
              id="item-container-builder__row-height-dialog__input"
              label={t("components.itemContainerBuilder.modals.height.input.label")}
              name="height"
              type="text"
              variant="outlined"
            />
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button id="item-container-builder__row-height-dialog__cancel-btn" onClick={onClose}>
          {t("commons.confirm.cancel")}
        </Button>
        <Button id="item-container-builder__row-height-dialog__confirm-btn" onClick={handleSubmit}>
          {t("commons.confirm.confirm")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default RowHeigthDialog;
